// A paired phone camera joins the room as `camera_<user_id>`: a player's own
// identity is their user id, and LiveKit kicks the older connection when an
// identity joins twice, so the phone needs its own. It maps to its owner's
// seat and is never counted as a person. The Rails side mirrors the format in
// LiveCameraPairing::IDENTITY_PREFIX.
export const CAMERA_IDENTITY_PREFIX = 'camera_';

export function buildCameraIdentity(userId) {
  return `${CAMERA_IDENTITY_PREFIX}${userId}`;
}

export function isCameraIdentity(identity) {
  return String(identity ?? '').startsWith(CAMERA_IDENTITY_PREFIX);
}

/** The owning user id of a camera identity, or null for any other identity. */
export function cameraOwnerId(identity) {
  if (!isCameraIdentity(identity)) return null;
  const owner = String(identity).slice(CAMERA_IDENTITY_PREFIX.length);
  return owner || null;
}
